import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useNavigate } from "react-router-dom";

import ContentCard from "../../../components/misc/ContentCard";
import DatePicker from "../../../components/misc/DatePicker";
import moment from "moment";
import FormButtons from "../../../components/misc/FormButtons";
import { fetchDownloadTemperatureChart } from "../../../redux/api/raports.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import { dateForDatabase } from "../../../utils/dateAndTime";
import { fetchFleet } from "../../../redux/api/fleet.api";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";

function VehicleTemperatureChart() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    fleet: {
      fleetData: {
        data: { data: fleetData },
      },
    },
  } = useAppSelector((state) => ({
    fleet: state.fleet,
  }));

  useEffect(() => {
    dispatch(
      fetchFleet({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const today = moment().format("YYYY-MM-DD");

  const [isLoading, setIsLoading] = useState(false);
  const [transportDay, setTransportDay] = useState<Date | null>(
    new Date(today),
  );
  const [selectedCars, setSelectedCars] = useState<DropdownValue[]>([]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDownloadTemperatureChart = async () => {
    if (!selectedCars.length) {
      return;
    }

    setIsLoading(true);

    const resultAction = await dispatch(
      fetchDownloadTemperatureChart({
        nrAuto: selectedCars,
        dataCursa: dateForDatabase(transportDay),
      }),
    );

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, fetchDownloadTemperatureChart) ===
      endpointStatus.fulfilled
    ) {
      setSelectedCars([]);
    }
  };

  const fleetNomenclaturesDropdownValues = useMemo(
    () =>
      fleetData?.map((item) => ({
        label: item.nrauto,
        id: item.id_auto,
      })),
    [fleetData],
  );

  const disableSubmit =
    !selectedCars.length ||
    selectedCars.some(({ label }) => {
      const nrAutoLength = label?.toString().length;

      return !nrAutoLength || nrAutoLength < 6 || nrAutoLength > 8;
    });

  return (
    <ContentCard
      cardTitle={"Descarca diagrama de temperatura autovehicul"}
      cardHeaderClassName="text-center"
      isLoading={isLoading}>
      <>
        <Dropdown
          className="my-4"
          title={"Selecteaza masinile"}
          data={fleetNomenclaturesDropdownValues}
          multipleValues={selectedCars}
          setMultipleValues={setSelectedCars}
        />

        <DatePicker
          label="Data incepere"
          maxDate={new Date()}
          value={transportDay}
          handleChangeDate={(value) => setTransportDay(value)}
        />
      </>

      <FormButtons
        goBackLabel="Inapoi"
        goNextLabel="Descarca diagrama"
        nextButtonVariant="action"
        nextButtonIcon="DOWNLOAD"
        nextButtonDisabled={disableSubmit}
        handleGoBack={handleGoBack}
        handleGoNext={handleDownloadTemperatureChart}
      />
    </ContentCard>
  );
}

export default VehicleTemperatureChart;
